import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

// Width of the docked copilot drawer.
export const PANEL_WIDTH = 400

// Floating circular launcher (FAB), pinned bottom-right — the standard spot for
// an AI assistant, clear of the content's row actions (Edit, etc.). It stays
// put: when the drawer opens it sits behind the higher z-index, full-height
// panel, so it never covers the ticket editor or the copilot's own input.
// Dismissal is via the header close button. The v2 three-stars svg paints with
// var(--color-primary-info); we set that var from the theme so the icon tracks
// the design-system colour.
const FAB_SIZE = 44
const FAB_MARGIN = 24

const toggleButton = theme => css`
  position: fixed;
  bottom: ${rem(FAB_MARGIN)};
  right: ${rem(FAB_MARGIN)};
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem(FAB_SIZE)};
  height: ${rem(FAB_SIZE)};
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${theme.color.primary.info};
  cursor: pointer;
  box-shadow: 0 ${rem(1)} ${rem(3)}
    rgba(${theme.color.monochrome.black_rgba}, 0.1);
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  svg {
    width: ${rem(20)};
    height: ${rem(20)};
    /* the three-stars svg paints with var(--color-primary-info); make it white
       against the info-coloured tile */
    --color-primary-info: ${theme.color.monochrome.white};
  }

  &:hover {
    transform: scale(1.06);
    box-shadow: 0 ${rem(2)} ${rem(5)}
      rgba(${theme.color.monochrome.black_rgba}, 0.12);
  }

  &:active {
    transform: scale(0.97);
  }

  &:focus-visible {
    outline: 2px solid ${theme.color.primary.info};
    outline-offset: 3px;
  }
`

const drawer = isOpen => theme => css`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: ${isOpen ? rem(PANEL_WIDTH) : 0};
  z-index: 2147483646;
  overflow: hidden;
  visibility: ${isOpen ? 'visible' : 'hidden'};
  background: ${theme.color.monochrome.white};
  box-shadow: ${isOpen
    ? `-${rem(4)} 0 ${rem(24)} rgba(${theme.color.monochrome.black_rgba}, 0.12)`
    : 'none'};
  transition: width 0.2s ease;
`

const iframe = css`
  width: ${rem(PANEL_WIDTH)};
  height: 100%;
  border: none;
`

export const styles = {
  toggleButton,
  drawer,
  iframe,
}
